import { Box, Typography } from '@mui/material';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

import { COLORS, INFO_BOX } from '../../IndividualPlan/tokens';

export const ASSESSMENT_DATA_ABSENT_BANNER =
  "No usable WIDA ACCESS results are on file. Enrollment, exits and time in program come from the district's student information system; growth and exit-rate sections fill in once results are uploaded and accepted.";

export function AssessmentDataAbsentBanner() {
  return (
    <Box
      role="status"
      data-testid="assessment-data-absent-banner"
      sx={{
        display: 'flex',
        gap: 2,
        alignItems: 'center',
        p: 2,
        mb: 3,
        borderRadius: 2,
        bgcolor: INFO_BOX.bg,
        border: `1px solid ${INFO_BOX.border}`,
      }}
    >
      <InfoOutlinedIcon sx={{ fontSize: 24, color: INFO_BOX.accent }} />
      <Typography component="p" sx={{ color: COLORS.ink, fontSize: 16, lineHeight: 1.5 }}>
        {ASSESSMENT_DATA_ABSENT_BANNER}
      </Typography>
    </Box>
  );
}

export function AssessmentDataAbsentSection({ measure }: { measure: string }) {
  return (
    <Typography
      component="p"
      data-testid="assessment-data-absent-section"
      sx={{ color: COLORS.muted, fontSize: 16, lineHeight: 1.5 }}
    >
      {`${measure} will appear once usable WIDA ACCESS results are on file.`}
    </Typography>
  );
}
